export default {"src":"/frontend-static/_next/static/media/thumb-up.2469e626.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};